import React from 'react'
import { graphql } from 'gatsby'
import loadable from '@loadable/component'
import Layout from 'components/layout'
import SEO from 'components/seo'

const RapidPlanControl = loadable(
  () => import('sections/RapidPlanControl/RapidPlanControl')
)
const Transform = loadable(() => import('sections/RapidPlanControl/Transform'))
const Calibrate = loadable(() => import('sections/RapidPlanControl/Features'))
const Contact = loadable(() => import('sections/RapidPlanControl/Contact'))
const Testimonials = loadable(
  () => import('sections/RapidPlanControl/Testimonials')
)

const RapidPlanControlPage = ({ data }) => {
  return (
    <Layout>
      <SEO title="RapidPlanControl" />
      <RapidPlanControl data={data} />
      <Calibrate />
      <Transform data={data} />
      <Testimonials />
      <Contact page="rapidplan-control" />
    </Layout>
  )
}

export const pageQuery = graphql`
  query {
    rapidplancontrol: file(relativePath: { eq: "RapidPlanControl_Cover.jpg" }) {
      ...fluidImage
    }
    transform: file(relativePath: { eq: "software.jpg" }) {
      ...fluidImage
    }
  }
`

export default RapidPlanControlPage
